import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const CtrlDeleteIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M19 2.5H16.08C15.37 1.15 13.77 0.25 12 0.25C10.23 0.25 8.63 1.13 7.92 2.5H5C3.48 2.5 2.25 3.73 2.25 5.25V6.75C2.25 7.64 2.92 8.37 3.79 8.48L4.94 22.6C4.99 23.24 5.54 23.75 6.19 23.75H17.83C18.48 23.75 19.02 23.25 19.08 22.6L20.23 8.48C21.09 8.37 21.77 7.64 21.77 6.75V5.25C21.77 3.73 20.54 2.5 19.02 2.5H19ZM12 1.75C12.85 1.75 13.64 2.03 14.19 2.5H9.81C10.36 2.03 11.15 1.75 12 1.75ZM17.59 22.25H6.41L5.29 8.5H18.7L17.58 22.25H17.59ZM20.25 6.75C20.25 6.89 20.14 7 20 7H4C3.86 7 3.75 6.89 3.75 6.75V5.25C3.75 4.56 4.31 4 5 4H19C19.69 4 20.25 4.56 20.25 5.25V6.75Z"
        fill={color}
      />
      <path
        d="M12 10.5C11.72 10.5 11.5 10.72 11.5 11V19C11.5 19.28 11.72 19.5 12 19.5C12.28 19.5 12.5 19.28 12.5 19V11C12.5 10.72 12.28 10.5 12 10.5Z"
        fill={color}
      />
      <path
        d="M7.96003 10.5C7.68003 10.52 7.48003 10.76 7.50003 11.04L8.17003 19.04C8.19003 19.3 8.41003 19.5 8.67003 19.5C8.68003 19.5 8.70003 19.5 8.71003 19.5C8.99003 19.48 9.19003 19.24 9.17003 18.96L8.50003 10.96C8.48003 10.69 8.24003 10.47 7.96003 10.5Z"
        fill={color}
      />
      <path
        d="M16.04 10.5C15.77 10.48 15.52 10.68 15.5 10.96L14.83 18.96C14.81 19.24 15.01 19.48 15.29 19.5C15.3 19.5 15.32 19.5 15.33 19.5C15.59 19.5 15.81 19.3 15.83 19.04L16.5 11.04C16.52 10.77 16.32 10.52 16.04 10.5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

CtrlDeleteIcon.displayName = 'CtrlDeleteIcon';
